var _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _path5, _rect4, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 118,
    viewBox: "0 0 108 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7302 13.2963V2.88086",
    stroke: "#FFD47E",
    strokeOpacity: 0.3,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4463 15.1061L32.0974 7.74121",
    stroke: "#FFD47E",
    strokeOpacity: 0.3,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9693 14.6432L71.3181 7.27832",
    stroke: "#FFD47E",
    strokeOpacity: 0.3,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.3904,
    y: 58.3291,
    width: 57.2761,
    height: 58.7896,
    fill: "#FFD47E",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1599 37.9609H73.7651L84.8265 58.329H31.2213L20.1599 37.9609Z",
    fill: "#FFD47E",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6794,
    y: 58.3291,
    width: 20.7857,
    height: 58.7896,
    fill: "#FFD47E",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5437,
    y: 55.5518,
    width: 58.1999,
    height: 53.6976,
    stroke: "#FFD47E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53491 30.0918H60.7348L72.7443 55.5519H14.5444L2.53491 30.0918Z",
    stroke: "#FFD47E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7389,
    y: 55.5518,
    width: 20.3238,
    height: 53.6976,
    stroke: "#FFD47E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8222 30.0918H105.534L93.0627 55.5519H72.7389",
    stroke: "#FFD47E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.c05669fd722c3581ae22107268f6a77b.svg";
export { ForwardRef as ReactComponent };